import React from 'react'
import { Link } from 'react-router-dom'
import { Image } from '../../../AbstractElements'
import { dynamicImage } from '../../../Utils'
import { Col } from 'reactstrap'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { RootState } from '../../../ReduxToolkit/Store'
import { setSideBarToggle } from '../../../ReduxToolkit/Reducers/Layout/LayoutReducer'
import SvgIcon from '../../../Utils/CommonComponents/CommonSvgIcons'
import { Href } from '../../../Utils/Constants'


export default function HorizontalLogo() {
    const dispatch = useDispatch();
    const { sideBarToggle } = useSelector((state: RootState) => state.layout);
    const handleSidebarToggle = () => {
        dispatch(setSideBarToggle(!sideBarToggle));
    };

    //Leggo il nome
    const panelConfig = useSelector((state: RootState) => state.panelConfig.data);
    const displayName = panelConfig?.nome ?? "Caricamento...";

    return (
        <Col xs="auto" className="logo-wrapper d-flex align-items-center">
            <Link to={`${process.env.PUBLIC_URL}/dashboard/default`}>
                {/* <Image className="light-logo img-fluid" src={dynamicImage(`logo/logo1.png`)} alt="logo" />
                <Image className="dark-logo img-fluid" src={dynamicImage(`logo/logo-dark.png`)} alt="logo" /> */}
                <h2 className='light-text'> {displayName}</h2>
                <h2 className='dark-text'> {displayName}</h2>
            </Link>
            <a style={{cursor:'pointer'}} className="close-btn toggle-sidebar"  onClick={handleSidebarToggle}>
                <SvgIcon className="svg-color" iconId="Category" />
            </a>
        </Col>
    )
}
